import React, {  useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import CohortDetailsComponent, { OrdersViewComp } from "./component";
import { toastr } from "react-redux-toastr";
import { useParams } from "react-router-dom";

import ClipboardJS from "clipboard";
import { useNavigate } from "react-router-dom";

const CohortViewContainer = (props) => {
  const { id } = useParams();
  
  const [orderData, setOrderData] = useState();
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [issue, setIssue] = useState("");
  const [orderStatus, setOrderStatus] = useState([])
  const [selectedIssue, setSelectedIssue] = useState("");
  const [refundId, setRefundId] = useState('')
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const navigate = useNavigate();
 const [cohortDetailsData, setCohortDetailsData]= useState({})



  const handleIssueChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedIssue(selectedValue);

    if (selectedValue !== "other") {
      
      setIssue(selectedValue);
    }
  };

  const handleIssueTextChange = (event) => {
   
    setIssue(event.target.value);
  };


const LoadCohortViewDetails = () => {
  return props.getDataFromAPI(
    `/dashboard/api/v2/admin/vendingmachines/vm-cohorts/${id}`,
    "GET",
    undefined,
    (response) => {
      setLoading(false);
      setCohortDetailsData(response);
      
     
     

    
    },
    (err) => {},
    true
  );
};
console.log("cohortDetailsData", cohortDetailsData)
useEffect(()=>{
  LoadCohortViewDetails()
},[])
 





  return (
    <>
      <CohortDetailsComponent
       
        show={show}
        handleClose={handleClose}
        handleShow={handleShow}
     
        handleIssueChange={handleIssueChange}
        selectedIssue={selectedIssue}
        handleIssueTextChange={handleIssueTextChange}
      
        orderStatus={orderStatus}
     cohortDetailsData={cohortDetailsData}
      />
     
    </>
  );
};

function mapStateToProps({ props }) {
  return {
    props,
  };
}
export default connect(mapStateToProps, {
  getDataFromAPI,
 
})(CohortViewContainer);
